import React, { forwardRef } from 'react';
import styles from './content-container.module.scss';

type ContentContainerProps = {
  children: React.ReactNode;
};

export const ContentContainer = forwardRef<HTMLDivElement, ContentContainerProps>(
  ({ children }, ref) => (
    <div className={styles.modalContainer} ref={ref}>
      <div className={styles.contentContainer}>{children}</div>
    </div>
  )
);
